var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUturnLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.46967 2.46979C8.76256 2.1769 9.23732 2.1769 9.53022 2.46979C9.82305 2.76269 9.82309 3.23746 9.53022 3.53034L4.81049 8.25007H14.9999C18.7278 8.2501 21.7499 11.2722 21.7499 15.0001C21.7499 18.7279 18.7278 21.75 14.9999 21.7501H11.9999C11.5857 21.7501 11.25 21.4143 11.2499 21.0001C11.2499 20.5859 11.5857 20.2501 11.9999 20.2501H14.9999C17.8994 20.25 20.2499 17.8995 20.2499 15.0001C20.2499 12.1006 17.8994 9.7501 14.9999 9.75007H4.81049L9.53022 14.4698L9.58197 14.5264C9.82223 14.821 9.8048 15.2558 9.53022 15.5303C9.25563 15.8049 8.82089 15.8224 8.52631 15.5821L8.46967 15.5303L2.46967 9.53034C2.17678 9.23745 2.17678 8.76269 2.46967 8.46979L8.46967 2.46979Z",
    fill: "#0F172A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUturnLeft);
export default __webpack_public_path__ + "static/media/arrow-uturn-left.f6a93d5dfcb0a2bd74911dbf726b9f36.svg";
export { ForwardRef as ReactComponent };